
import { useState } from "react";
import Part1 from "../../BAccount/parts/tabsI/part1";
import Part3 from "../../BAccount/parts/tabsI/part3";
import { useSelector } from "react-redux";
const Pidentification = () => {
  const [wow, setWow] = useState(0);
  const profileData = useSelector((state) => state.profileData);
  const Show = [Part1,Part3];
  const Dis = Show[wow];
  return (
    <div className="">
      {profileData.verificationDocs && (
        <div>
          <div className="flex mt-8 mb-[5rem]">
            <button
              onClick={() => setWow(0)}
              className={` ${
                wow === 0 ? "bg-primary text-white" : "bg-[#EDEDED]"
              } flex p-2 rounded-xl flex items-center justify-center  mr-2 min-w-[5.5rem] pl-4 pr-4 relative mt-5`}
            >
              <div className=" text-center w-[100%]">IDs / Certificates</div>
              <div
                className={`${
                  wow === 0 ? "" : "hidden"
                } arrow-down absolute right-[35%] bottom-[-38%]`}
              ></div>
            </button>
            <button
              onClick={() => setWow(1)}
              className={`${
                wow === 1 ? "bg-primary text-white" : "bg-[#EDEDED]"
              } flex p-2 rounded-xl flex items-center justify-center  mr-2 min-w-[5.5rem] pl-4 pr-4 relative mt-5`}
            >
              <div className=" text-center w-[100%]">Tax Information</div>
              <div
                className={`${
                  wow === 1 ? "" : "hidden"
                } arrow-down absolute right-[35%] bottom-[-38%]`}
              ></div>
            </button>
          
          </div>
          <Dis />
        </div>
      )}
    </div>
  );
};

export default Pidentification;
